import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CardHeader } from '../CardHeader';
import { useViewTransition } from '@/hooks/useViewTransition';
import { useCountdown } from '@/hooks/useCountdown';
import { ChangingNumbers } from '../Game/ChangingCents';


export function JackpotCard() {
  const { navigateNormal } = useViewTransition(); 
  const { days } = useCountdown();

  return (
    <Card className="max-w-md rounded-lg overflow-hidden shadow-md bg-white border-0 btn-bounce-subtle">
      <CardHeader title="Upcoming Jackpot" />
      <CardContent className="p-0">
        {/* Main content */}
        <div className="px-3 pt-6 pb-4 text-center">
          {/* Title */}
          <h2 className="text-3xl font-bold text-pink-500 mb-3">
            Weekly Power Win
          </h2>

          <span className="text-slate text-xl text-blue-dark">200 prizes. Win up to:</span>
          
          {/* Prize amount */}
          <div className="text-5xl font-semibold text-slate my-3">
            $<ChangingNumbers from={0} to={4600000} decimals={0}/>
          </div>
          
          {/* Status and price */}
          <div className="flex items-center justify-center gap-4 text-lg mb-4">
            <span className="text-slate text-xl">Very Popular</span>
            <div className="h-6 border-l border-gray-200 translate-y-0.5" />
            <span className="text-slate text-xl">Entry: $1</span>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="flex justify-center mb-4">
            <Button 
            className="py-6 bg-blue text-white text-2xl font-bold px-16 rounded-lg"
            shine
            onClick={() => navigateNormal('/jackpot',
                {
                    replace: false,
                    viewTransition: true,
                }
            )}
            >
                Entry Options
            </Button>
        </ div>

        <div className='mb-0 mt-auto h-10 bg-pink-300 w-1/2 mx-auto rounded-tl-xl rounded-tr-xl flex justify-center
        items-center text-xl text-white font-bold'>
            Ends in {days} days
        </div>
      </CardContent>
    </Card>
  );
};